<template>
  <div class="app-footer-wrap">
    <!-- 占位：避免固定页脚遮住页面内容 -->
    <div class="app-footer-holder"></div>

    <div class="app-footer">
      <div class="app-footer__inner">
        <!-- 客服信息 -->
        <div class="app-footer__contact">
          <span class="app-footer__item">客服邮箱：{{ configdata.maile }}</span>
          <i class="app-footer__sep"></i>
          <span class="app-footer__item">联系电话：{{ configdata.servicephone }}</span>
          <i class="app-footer__sep"></i>
          <span class="app-footer__item">工作日 9:00-18:00</span>
        </div>

        <div class="app-footer__line"></div>

        <!-- 版权与备案 -->
        <div class="app-footer__meta">
          <span class="app-footer__item">Copyright © 2019-2025 西安盛唐启航信息科技有限公司 ALL Rights Reserved 版权所有</span>
          <a class="app-footer__item" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">工信部备案号：{{ configdata.sitebeian }}</a>
          <span class="app-footer__item app-footer__item--police">
            <img :src="police" alt="">公安网备案号：{{ configdata.policebeiansn }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import police from "@/assets/police.png";

export default {
  name: 'AppFooter',
  data() {
    return {
      police,
      configdata: {}
    }
  },
  created() {
    var configdata = JSON.parse(localStorage.getItem('configdata'))
    this.configdata = configdata || {}
  }
}
</script>

<style lang="scss" scoped>
/* 固定页脚高度，占位块与之保持一致 */
$footer-h: 106px;

.app-footer-holder {
  height: $footer-h;
}

.app-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: $footer-h;
  padding: 16px 24px;
  box-sizing: border-box;
  background: #2b3038;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
}

.app-footer__inner {
  width: 100%;
  max-width: 1200px;
}

/* 第一行：客服信息 */
.app-footer__contact {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.92);
}

.app-footer__sep {
  width: 1px;
  height: 12px;
  margin: 0 22px;
  background: rgba(255, 255, 255, 0.18);
}

/* 分隔线 */
.app-footer__line {
  height: 1px;
  margin: 12px 0;
  background: rgba(255, 255, 255, 0.1);
}

/* 第二行：版权与备案 */
.app-footer__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 4px 28px;
  font-size: 13px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.62);
}

.app-footer__item {
  white-space: nowrap;
}

.app-footer__meta a {
  color: rgba(255, 255, 255, 0.62);
  text-decoration: none;

  &:hover {
    color: #fff;
    text-decoration: underline;
  }
}

.app-footer__item--police {
  display: inline-flex;
  align-items: center;

  img {
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
}

@media screen and (max-width: 768px) {
  .app-footer {
    padding: 12px 16px;
  }

  .app-footer__contact {
    font-size: 12px;
  }

  .app-footer__sep {
    margin: 0 10px;
  }

  .app-footer__meta {
    gap: 2px 14px;
    font-size: 11px;
  }
}
</style>
